<template>
  <div class="hot-label">
    <div>{{title}}</div>
<!--    <span class="tail-icon">{{tailLabel}}</span>-->
    <img v-if="tailImg" class="tail-icon" :src="tailImg">
  </div>
</template>

<script>
  import HotImg from '../../assets/shl_label_hot_notice_hot.png';
  import ImpImg from '../../assets/shl_label_hot_notice_imp.png';
  import TopsetImg from '../../assets/shl_label_hot_notice_topset.png';
  import SignImg from '../../assets/shl_label_hot_notice_sign.png';
  import DoingImg from '../../assets/shl_label_hot_notice_doing.png';
export default {
  name: "HotLabel",
  props: [
    'title',
    'flag',
    'flagInvalidTIme'
  ],
  data() {
    return {
      labelClass: [],
      tailLabel: '',
      tailImg: '',
    }
  },
  computed: {
  },
  mounted() {
    setTimeout(this.caculateClass, 50);
  },
  methods: {
    caculateClass() {
      let flag = this.flag;
      if (flag == undefined || flag == null || flag == '') {
        this.tailImg = '';
        return;
      }

      let tmp = flag.split(',');
      let labelType = tmp[0];

      let invalidTime = this.flagInvalidTIme;
      if (invalidTime == undefined || invalidTime == null || invalidTime == '') {
        this.tailImg = '';
        return;
      }

      let now = this.$moment(this.$moment().format('YYYY-MM-DD'), 'YYYY-MM-DD');
      // console.log(invalidTime);
      let invalidDate = this.$moment(invalidTime);
      // console.log(invalidDate.format('YYYY-MM-DD HH:mm:sss'));
      if (invalidDate - now < 0) {
        this.tailImg = '';
        return;
      }

      if (labelType == '热门') { // 热门
        this.tailImg = HotImg;
      } else if (labelType == '重要') { // 重要
        this.tailImg = ImpImg;
      } else if (labelType == '置顶') { // 置顶
        this.tailImg = TopsetImg;
      } else if (labelType == '报名中') { // 报名中
        this.tailImg = SignImg;
      } else if (labelType == '进行中') { // 进行中
        this.tailImg = DoingImg;
      }
    }
  }
}
</script>

<style scoped>

  .hot-label {
    color: #333;
    font-size: 1rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  .hot-label .tail-icon {
    height: 14px;
    width: auto;
    margin-left: 3px;
  }

  .hot-label div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/HotLabel.vue